import { render, staticRenderFns } from "./MalDetayKarlilikDialog.vue?vue&type=template&id=f866dffe&scoped=true"
import script from "./MalDetayKarlilikDialog.vue?vue&type=script&lang=js"
export * from "./MalDetayKarlilikDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f866dffe",
  null
  
)

export default component.exports